'use client';

import { Copy } from 'lucide-react';
import { useMemo } from 'react';
import toast from 'react-hot-toast';

import { Button } from '@/components/ui/button';

interface PaymentInfoProps {
  amount: number;
  bankName: string;
  accountNumber: string;
  accountHolder: string;
}

export default function PaymentInfo({ amount, bankName, accountNumber, accountHolder }: PaymentInfoProps) {
  const isClipboardSupported = useMemo(() => {
    return typeof navigator !== 'undefined' && !!navigator.clipboard;
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(`${bankName} ${accountNumber} (${accountHolder})`);
      toast.success('계좌번호가 복사되었습니다.');
    } catch {
      toast.error('계좌번호 복사에 실패했습니다.');
    }
  };

  return (
    <div className="space-y-3">
      <div className="flex justify-between items-center">
        <span className="text-base font-semibold text-neutral-600">금액</span>
        <span className="text-base font-bold text-neutral-800">{amount.toLocaleString()}원</span>
      </div>
      <div className="flex justify-between items-center">
        <span className="text-base font-semibold text-neutral-600">입금계좌</span>
        <div className="flex items-center gap-2">
          <span className="text-base font-bold text-neutral-800 select-text">
            {bankName} {accountNumber} ({accountHolder})
          </span>
          {isClipboardSupported && (
            <Button
              variant="ghost"
              size="icon"
              onClick={handleCopy}
              className="h-8 w-8 active:bg-gray-100 duration-150"
            >
              <Copy className="h-4 w-4 text-neutral-600" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
